<template>
<div class="footer">
    <div class="wrap flex justify-between">
        <div class="fmain">
            <div class="nav">
                <ul class="flex">
                    <li><router-link to="/">首页</router-link></li>
                    <li><router-link to="/about">关于国正</router-link></li>
                    <li><router-link to="/products">服务项目</router-link></li>
                    <li><router-link to="/news?id=1">新闻中心</router-link></li>
                    <li><router-link to="/companyNews/3">网上信息公开</router-link></li>
                    <li><router-link to="/downloads">文件下载</router-link></li>
                    <li><router-link to="/joinUs">加入国正</router-link></li>
                    <!-- <li><router-link to="/service">社会化服务事业部</router-link></li> -->
                    <li><router-link to="/contact">联系我们</router-link></li>
                </ul>
            </div>
            <div class="footerContact">
                <div class="tel">
                    <dl>咨询热线：</dl>
                    <ol class="mobile">0575-84818999</ol>
                </div>
                <div class="add">
                    总部地址：浙江省绍兴市柯桥区华舍街道金柯桥大道1358号国贸大厦17-20 楼<br>
                    E-mail：guozhengjiance@163.com
                </div>
            </div>
            <div class="copyright">
                Copyright © 2023 浙江国正安全技术有限公司
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                浙ICP备16030291号-1
              </a>
            </div>
        </div>
        <div class="flogo">
            <img src="@/assets/flogo.png" alt="">
        </div>
    </div>
</div>
</template>

<script setup>

</script>

<style scoped>
dl, ol  {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0;
}

/* 组件样式 */
.footer {
    padding: 60px 0;
    background: #dedede;
    font-size: 14px;
}

.footer .wrap {
    padding: 0 30px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    width: 1380px;
    max-width: 100%;
}

.footer .wrap .fmain .nav {
    border-bottom: #bebebe solid 1px;
}

.footer .wrap .fmain .nav ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
}

.footer .wrap .fmain .nav ul li {
    margin-right: 40px;
    margin-bottom: 10px;
}

.footer .wrap .fmain .nav ul li a {
    font-size: 14px;
    line-height: 80px;
    text-decoration: none;
    color: #333;
}

.footer .wrap .fmain .nav ul li a:hover {
    color: #00437c;
}

.footer .wrap .fmain .footerContact {
    padding: 30px 0;
    border-bottom: #bebebe solid 1px;
    margin-bottom: 18px;
    display: flex;
}

.footer .wrap .fmain .footerContact .tel {
    margin-right: 80px;
}

.footer .wrap .fmain .footerContact .tel dl {
    line-height: 30px;
    color: #333;
}

.footer .wrap .fmain .footerContact .add {
    line-height: 30px;
    color: #333;
}

.footer .wrap .fmain .footerContact .mobile {
    font-size: 25px;
    font-weight: bold;
    color: #000;
    padding-inline-start: 0;
}

.flogo {
    width: 25%;
    text-align: right;
    margin-top: 80px;
}

.flogo img {
    display: inline-block;
    vertical-align: middle;
    max-width: 75px;
    max-height: 100%;
    height: auto;
    border: none;
}

/* 响应式设计 */
@media screen and (max-width: 1400px) {
    .footer .wrap {
        width: 100%;
    }
}

@media screen and (max-width: 768px) {
    .footer {
        padding: 40px 0;
    }

    .footer .wrap {
        flex-direction: column;
        padding: 0 15px;
    }

    .footer .wrap .fmain {
        width: 100%;
    }

    .footer .wrap .fmain .nav ul {
        justify-content: center;
        text-align: center;
    }

    .footer .wrap .fmain .nav ul li {
        margin-right: 20px;
        margin-bottom: 5px;
    }

    .footer .wrap .fmain .nav ul li a {
        line-height: 40px;
        font-size: 13px;
    }

    .footer .wrap .fmain .footerContact {
        flex-direction: column;
        text-align: center;
        padding: 20px 0;
    }

    .footer .wrap .fmain .footerContact .tel {
        margin-right: 0;
        margin-bottom: 20px;
    }

    .footer .wrap .fmain .footerContact .mobile {
        font-size: 20px;
    }

    .footer .wrap .fmain .footerContact .add {
        font-size: 13px;
        line-height: 1.6;
    }

    .flogo {
        width: 100%;
        text-align: center;
        margin-top: 20px;
    }

    .flogo img {
        max-width: 60px;
    }
}

@media screen and (max-width: 480px) {
    .footer .wrap .fmain .nav ul li {
        margin-right: 15px;
    }

    .footer .wrap .fmain .nav ul li a {
        font-size: 12px;
    }

    .footer .wrap .fmain .footerContact .mobile {
        font-size: 18px;
    }

    .footer .wrap .fmain .footerContact .add {
        font-size: 12px;
    }
}
</style>
